import { css } from '@leafygreen-ui/emotion';
import { spacing } from '@leafygreen-ui/tokens';

export const radioGroupStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]}px;
`;
